module.exports = __webpack_public_path__ + "img/4-5.45510d60.svg";